// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1OUri","author":"Table_author__3rdB6","authorImage":"Table_authorImage__25Rsi","unreadRow":"Table_unreadRow__3SWm_"};